<template>
  <div class="analysis__detail__wrapper">
    <!-- Header -->
    <div class="analysis__detail__header">
      <div class="analysis__detail__container">
        <!-- <a href="https://codmos.io"> -->
        <div class="analysis__logo"></div>
        <!-- </a> -->
        <!-- <a href="/codmos/analysis">
          <div class="analysis__exit"></div>
        </a> -->
      </div>
    </div>

    <!-- Contents -->
    <div class="analysis__detail__contents">
      <div class="box1">
        <div class="analysis__detail__title">
          <p>사전교육 패키지 학습 상세 결과</p>
        </div>
      </div>
      <div class="box2">
        <div class="box2-1">
          <div class="title">미션해결</div>
          <div class="progress-container">
            <div class="progress-bg-title">순차 :</div>
            <div
              v-for="idx in 10"
              :key="idx"
              :class="[ idx <= misSucCnt1 ? 'progress-bg-order' : 'progress-bg']"
            ></div>
            <div class="progress-bg-contents">{{misSucCnt1}}/10</div>
          </div>

          <div class="progress-container">
            <div class="progress-bg-title">반복 :</div>
            <div
              v-for="idx in 10"
              :key="idx"
              :class="[ idx <= misSucCnt2 ? 'progress-bg-repeat' : 'progress-bg']"
            ></div>
            <div class="progress-bg-contents">{{misSucCnt2}}/10</div>
          </div>
          <div class="progress-container">
            <div class="progress-bg-title">선택 :</div>
            <div
              v-for="idx in 10"
              :key="idx"
              :class="[ idx <= misSucCnt3 ? 'progress-bg-select' : 'progress-bg']"
            ></div>
            <div class="progress-bg-contents">{{misSucCnt3}}/10</div>
          </div>
          <div class="progress-container">
            <div class="progress-bg-title">변수 :</div>
            <div
              v-for="idx in 10"
              :key="idx"
              :class="[ idx <= misSucCnt4 ? 'progress-bg-variable' : 'progress-bg']"
            ></div>
            <div class="progress-bg-contents">{{misSucCnt4}}/10</div>
          </div>
        </div>
        <div class="box2-2">
          <div class="box2-2__title">전체 미션 성공률</div>
          <div class="box2-2__border"></div>
          <div class="box2-2__contents">{{totSucMiRate}}%<br />({{misSucCnt1+misSucCnt2+misSucCnt3+misSucCnt4}}/40)</div>
        </div>
      </div>
      <div class="box3">
        <div class="box-title">전체지표</div>
        <div class="box3-sub left">
          <div class="title title1">
            학습시간
            <img
              class="icon"
              @click="showModal('analysis-alert-template', '학습시간이란?', '모든 미션을 실행하여 해결하기까지 걸린 전체 학습 시간입니다.')"
              src="../assets/images/analysis/btn_question_mark.png"
            >
          </div>
          <div class="contents">
            <div class="contents contents__border"></div>
            <p class="contents contents__title1">{{totalStudyTime}}</p>
          </div>
        </div>
        <div class="box3-sub">
          <div class="title title2">
            <div>평균 해결 시간</div>
            <img
              class="icon"
              @click="showModal('analysis-alert-template', '평균해결시간이란?', '모든 미션을 실행하여 해결하기까지 걸린 전체 학습 시간을 해결한 미션의 수로 나눈 값입니다.')"
              src="../assets/images/analysis/btn_question_mark.png"
            >
          </div>
          <div class="contents">
            <div class="contents contents__border"></div>
            <p class="contents contents__title1">{{avgSolTime}}</p>
          </div>
        </div>
        <div class="box3-sub">
          <div class="title title3">
            첫 시도 성공률
            <img
              class="icon"
              @click="showModal('analysis-alert-template', '첫시도 성공률이란?', '총 미션 중 미션을 실행하여 실패하지 않고 한번에 성공한 미션의 비율입니다.')"
              src="../assets/images/analysis/btn_question_mark.png"
            >
          </div>
          <div class="contents">
            <div class="contents contents__border"></div>
            <p class="contents contents__title1">{{frtTrySucRate0}}%</p>
          </div>
        </div>
        <div class="box3-sub">
          <div class="title title4">
            블록 사용 달성률
            <img
              class="icon"
              @click="showModal('analysis-alert-template', '블록사용 달성률이란?', '총 미션 중 미션별로 주어진 목표블록 개수에 맞추어 문제를 해결한 미션의 비율입니다.')"
              src="../assets/images/analysis/btn_question_mark.png"
            >
          </div>
          <div class="contents">
            <div class="contents contents__border"></div>
            <p class="contents contents__title1">{{blkUseSucRate0}}%</p>
          </div>
        </div>
      </div>
      <div class="box4">
        <div class="box4_0">&nbsp;</div>
        <div class="box4_1">개념별 학습 결과</div>
        <div class="box4_2">
          <div class="box4_2_left">
            <div class="box4_2_left_tag1">미션 성공률</div>
            <div class="box4_2_left_tag2">첫 시도 성공률</div>
            <div class="box4_2_left_chart">
              <!--<v-radar-->
              <!--:chartdata="chartdata"-->
              <!--:chartoptions="chartoptions">-->
              <!--</v-radar>-->
              <v-radar ref="vchart">
              </v-radar>
            </div>
            <div class="box4_2_left_tag3">
              <p>블록사용 달성률</p>
            </div>
          </div>
          <div class="box4_2_right">
            <div>
              <div class="green_box"></div>
              <div class="box4_2_right_title">변수</div>
            </div>
            <div>
              <div class="blue_box"></div>
              <div class="box4_2_right_title">선택</div>
            </div>
            <div>
              <div class="yellow_box"></div>
              <div class="box4_2_right_title">반복</div>
            </div>
            <div>
              <div class="pink_box"></div>
              <div class="box4_2_right_title">순차</div>
            </div>
          </div>
        </div>
        <div class="box4_3">
          <div
            id="tabs"
            class="a-container"
          >
            <div class="tabs">
              <a
                v-on:click="changeActiveTab(1)"
                v-bind:class="[ activetab === 1 ? 'active' : '' ]"
              >전체</a>
              <a
                v-on:click="changeActiveTab(2)"
                v-bind:class="[ activetab === 2 ? 'active' : '' ]"
              >순차</a>
              <a
                v-on:click="changeActiveTab(3)"
                v-bind:class="[ activetab === 3 ? 'active' : '' ]"
              >반복</a>
              <a
                v-on:click="changeActiveTab(4)"
                v-bind:class="[ activetab === 4 ? 'active' : '' ]"
              >선택</a>
              <a
                v-on:click="changeActiveTab(5)"
                v-bind:class="[ activetab === 5 ? 'active' : '' ]"
              >변수</a>
            </div>
            <div class="content">
              <div
                v-if="activetab === 1"
                class="tabcontent"
              >
                <div class="sub-contents">
                  <div>전체 문제 해결시간은</div>
                  <div class="data_bg"><span>{{totalStudyTime}}</span></div>
                  <div>이며,</div> <br />
                  <div>전체 평균 해결시간은</div>
                  <div class="data_bg"><span>{{avgSolTime}}</span></div>
                  <div>입니다.</div><br /><br />
                  <div>첫시도 성공률은</div>
                  <div class="data_bg"><span>{{frtTrySucRate0}}%</span></div>
                  <div>이며, 블록사용 달성률은</div>
                  <div class="data_bg"><span>{{blkUseSucRate0}}%</span></div>
                  <div>입니다.</div>
                </div>
              </div>
              <div
                v-if="activetab === 2"
                class="tabcontent"
              >
                <div class="sub-title">
                  <div class="sub-title-left">순차</div>
                  <div class="sub-title-right">명령을 차례차례 실행하는 '순차'구조</div>
                </div>
                <div class="sub-contents">
                  <div>순차 문제 해결시간은</div>
                  <div class="data_bg"><span>{{totalStudyTime1}}</span></div>
                  <div>소요되었으며,</div><br />
                  <div>미션 평균 해결시간은</div>
                  <div class="data_bg"><span>{{avgSolTime1}}</span></div>
                  <div>소요되었습니다.</div><br /><br />
                  <div>순차 개념 10문제 중</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{misSucCnt1}}</span></div>
                  <div>문제를 성공하였으며 이중</div>
                  <div class="data_bg"><span>{{frtSucMiCnt1}}</span></div>
                  <div>문제를 첫 시도에 성공하여</div><br />
                  <div>첫 시도 성공률</div>
                  <div class="data_bg"><span>{{frtTrySucRate1}}%</span></div>
                  <div>를 달성하였습니다.</div><br /><br />
                  <div>또한 주어진 미션 해결을 위해 제시된 목표 블록에 맞게 문제를 해결한 미션이</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{blkSucMiCnt1}}</span></div>
                  <div>문제로 블록사용 달성률</div>
                  <div class="data_bg"><span>{{blkUseSucRate1}}%</span></div>
                  <div>를 달성하였습니다.</div>
                </div>
              </div>
              <div
                v-if="activetab === 3"
                class="tabcontent"
              >
                <div class="sub-title">
                  <div class="sub-title-left">반복</div>
                  <div class="sub-title-right">계속 같은 행동을 되풀이하는 '반복'구조</div>
                </div>
                <div class="sub-contents">
                  <div>반복 문제 해결시간은</div>
                  <div class="data_bg"><span>{{totalStudyTime2}}</span></div>
                  <div>소요되었으며,</div><br />
                  <div>미션 평균 해결시간은</div>
                  <div class="data_bg"><span>{{avgSolTime2}}</span></div>
                  <div>소요되었습니다.</div><br /><br />
                  <div>반복 개념 10문제 중</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{misSucCnt2}}</span></div>
                  <div>문제를 성공하였으며 이중</div>
                  <div class="data_bg"><span>{{frtSucMiCnt2}}</span></div>
                  <div>문제를 첫 시도에 성공하여</div><br />
                  <div>첫 시도 성공률</div>
                  <div class="data_bg"><span>{{frtTrySucRate2}}%</span></div>
                  <div>를 달성하였습니다.</div><br /><br />
                  <div>또한 주어진 미션 해결을 위해 제시된 목표 블록에 맞게 문제를 해결한 미션이</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{blkSucMiCnt2}}</span></div>
                  <div>문제로 블록사용 달성률</div>
                  <div class="data_bg"><span>{{blkUseSucRate2}}%</span></div>
                  <div>를 달성하였습니다.</div>
                </div>
              </div>
              <div
                v-if="activetab === 4"
                class="tabcontent"
              >
                <div class="sub-title">
                  <div class="sub-title-left">선택</div>
                  <div class="sub-title-right">주어진 조건에 따라 각각 다른 행동을 하는 '선택' 구조</div>
                </div>
                <div class="sub-contents">
                  <div>선택 문제 해결시간은</div>
                  <div class="data_bg"><span>{{totalStudyTime3}}</span></div>
                  <div>소요되었으며,</div><br />
                  <div>미션 평균 해결시간은</div>
                  <div class="data_bg"><span>{{avgSolTime3}}</span></div>
                  <div>소요되었습니다.</div><br /><br />
                  <div>선택 개념 10문제 중</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{misSucCnt3}}</span></div>
                  <div>문제를 성공하였으며 이중</div>
                  <div class="data_bg"><span>{{frtSucMiCnt3}}</span></div>
                  <div>문제를 첫 시도에 성공하여</div><br />
                  <div>첫 시도 성공률</div>
                  <div class="data_bg"><span>{{frtTrySucRate3}}%</span></div>
                  <div>를 달성하였습니다.</div><br /><br />
                  <div>또한 주어진 미션 해결을 위해 제시된 목표 블록에 맞게 문제를 해결한 미션이</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{blkSucMiCnt3}}</span></div>
                  <div>문제로 블록사용 달성률</div>
                  <div class="data_bg"><span>{{blkUseSucRate3}}%</span></div>
                  <div>를 달성하였습니다.</div>
                </div>
              </div>
              <div
                v-if="activetab === 5"
                class="tabcontent"
              >
                <div class="sub-title">
                  <div class="sub-title-left">변수</div>
                  <div class="sub-title-right">처리 또는 기억이 필요한 자료를 저장할 수 있는 '변수'</div>
                </div>
                <div class="sub-contents">
                  <div>변수 문제 해결시간은</div>
                  <div class="data_bg"><span>{{totalStudyTime4}}</span></div>
                  <div>소요되었으며,</div><br />
                  <div>미션 평균 해결시간은</div>
                  <div class="data_bg"><span>{{avgSolTime4}}</span></div>
                  <div>소요되었습니다.</div><br /><br />
                  <div>변수 개념 10문제 중</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{misSucCnt4}}</span></div>
                  <div>문제를 성공하였으며 이중</div>
                  <div class="data_bg"><span>{{frtSucMiCnt4}}</span></div>
                  <div>문제를 첫 시도에 성공하여</div><br />
                  <div>첫 시도 성공률</div>
                  <div class="data_bg"><span>{{frtTrySucRate4}}%</span></div>
                  <div>를 달성하였습니다.</div><br /><br />
                  <div>또한 주어진 미션 해결을 위해 제시된 목표 블록에 맞게 문제를 해결한 미션이</div><br />
                  <div>총</div>
                  <div class="data_bg"><span>{{blkSucMiCnt4}}</span></div>
                  <div>문제로 블록사용 달성률</div>
                  <div class="data_bg"><span>{{blkUseSucRate4}}%</span></div>
                  <div>를 달성하였습니다.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="box4_3">
          <a href="/codmos/analysis">
            <div class="analysis__detail__exit">닫기</div>
          </a>
        </div> -->
      </div>
      <div class="analysis__detail__exit">
        <div
          class="analysis__request__detail"
          onclick="location.href='/codmos/analysis'"
        >닫기</div>
      </div>
    </div>
    <component
      v-if="isShowModal"
      :is="modal"
      :title="modalTitle"
      :data="modalData"
      @close="isShowModal = false"
      :userDevice="userDevice"
      :confirm="confirm"
    ></component>
  </div>
</template>
<script>

require('@fortawesome/fontawesome-free');

import { was } from '@/lib/axios';
import mobileDetect from 'mobile-detect'
import moment from 'moment'
import momentDuration from 'moment-duration-format'
momentDuration(moment);
import vRadar from './CodmosAnalysisRadarChart'


// import mapStageTemplate from './map/MapPartialStage'
// import mapHeaderTemplate from './map/MapPartialHeader'
// import mapAlertTemplate from './map/MapAlert'
import analysisAlertTemplate from './modal/AnalysisModal'


const BROWSER_TYPE = navigator.userAgent.toLowerCase();
let gaScript;
if (
  BROWSER_TYPE.indexOf('msie 10.0') > -1 // IE 10
  || BROWSER_TYPE.indexOf('msie 9.0') > -1 // IE 9
  || BROWSER_TYPE.indexOf('msie 8.0') > -1 // IE 8
  || BROWSER_TYPE.indexOf('msie 7.0') > -1 // IE 7
) gaScript = require('../../static/assets/js/utility/googleanalytics-ie10');
else gaScript = require('../../static/assets/js/utility/googleanalytics');

let cmpList;
if (window.NODE_ENV === 'production' && window.NODE_REL === 'release') {
  cmpList = {
    // mapStageTemplate,
    // mapHeaderTemplate,
    // mapAlertTemplate,
    'v-radar': vRadar,
    'analysisAlertTemplate': analysisAlertTemplate,
    'gaScript': gaScript
  };
} else {
  cmpList = {
    // mapStageTemplate,
    // mapHeaderTemplate,
    // mapAlertTemplate,
    'v-radar': vRadar,
    'analysisAlertTemplate': analysisAlertTemplate,
  };
}
export default {
  name: "CodmosResultDetail",
  components: cmpList,
  data () {
    return {
      percentage: 70,
      desc: [
        // ['소프트웨어 세상을 여행하려면 명령어 블록을 위에서부터 차례차례 실행해야 해!', '이렇게 명령을 차례차례 실행하는 모양을 \'순차\' 구조라고 부른다는 사실 꼭 기억해 줘!'],
        // ['앞으로 이동하고, 앞으로 이동하고, 앞으로 이동하고... 무언가 더 편한 방법이 없을까?', '계속 같은 행동을 되풀이해야 한다면 \'반복\' 구조를 사용해 더욱 쉽게 움직일 수 있어!'],
        // ['만약 앞에 아이템이 있다면? 또는 없다면? 이렇게 상황에 따라 행동하려면 어떻게 해야 할까?', '주어진 조건에 따라 각각 다른 행동을 하려면 \'선택\' 구조의 도움을 받아 보는 게 어때?']
      ],
      isShowModal: false,
      modal: '',
      modalTitle: '',
      modalData: null,
      isLoading: false,
      allClear: false,
      userDevice: 'pc',
      isLoginPopup: false,
      confirm: '',
      activetab: 1,
      misSucCnt1: 0,
      misSucCnt2: 0,
      misSucCnt3: 0,
      misSucCnt4: 0,
      frtSucMiCnt1: 0,
      frtSucMiCnt2: 0,
      frtSucMiCnt3: 0,
      frtSucMiCnt4: 0,
      misSucRate1: 0,
      misSucRate2: 0,
      misSucRate3: 0,
      misSucRate4: 0,
      totSucMiRate: 0,
      frtTrySucRate0: 0,
      frtTrySucRate1: 0,
      frtTrySucRate2: 0,
      frtTrySucRate3: 0,
      frtTrySucRate4: 0,
      blkUseSucRate0: 0,
      blkSucMiCnt1: 0,
      blkSucMiCnt2: 0,
      blkSucMiCnt3: 0,
      blkSucMiCnt4: 0,
      blkUseSucRate1: 0,
      blkUseSucRate2: 0,
      blkUseSucRate3: 0,
      blkUseSucRate4: 0,
      totalStudyTime: '',
      totalStudyTime1: '',
      totalStudyTime2: '',
      totalStudyTime3: '',
      totalStudyTime4: '',
      avgSolTime: '',
      avgSolTime1: '',
      avgSolTime2: '',
      avgSolTime3: '',
      avgSolTime4: ''
    }
  },
  created () {
    const MD = new mobileDetect(window.navigator.userAgent);

    if (MD.tablet() !== null) this.userDevice = 'tablet';
    else if (MD.mobile() !== null) this.userDevice = 'mobile';

    // this.getUser()
  },
  mounted: function () {
    this.isLoading = false;
    let analysisInfo = JSON.parse(localStorage.analysisInfo);
    this.misSucCnt1 = analysisInfo.misSucCnt1;
    this.misSucCnt2 = analysisInfo.misSucCnt2;
    this.misSucCnt3 = analysisInfo.misSucCnt3;
    this.misSucCnt4 = analysisInfo.misSucCnt4 || 0;
    this.frtSucMiCnt1 = analysisInfo.frtSucMiCnt1;
    this.frtSucMiCnt2 = analysisInfo.frtSucMiCnt2;
    this.frtSucMiCnt3 = analysisInfo.frtSucMiCnt3;
    this.frtSucMiCnt4 = analysisInfo.frtSucMiCnt4 || 0;
    this.misSucRate1 = parseInt((this.misSucCnt1 / 10 * 100).toFixed(0));
    this.misSucRate2 = parseInt((this.misSucCnt2 / 10 * 100).toFixed(0));
    this.misSucRate3 = parseInt((this.misSucCnt3 / 10 * 100).toFixed(0));
    this.misSucRate4 = parseInt((this.misSucCnt4 / 10 * 100).toFixed(0)) || 0;
    this.totSucMiRate = ((this.misSucCnt1 + this.misSucCnt2 + this.misSucCnt3 + this.misSucCnt4) / 40 * 100).toFixed(0);
    this.frtTrySucRate0 = analysisInfo.frtTrySucRate0;
    this.frtTrySucRate1 = parseInt(analysisInfo.frtTrySucRate1);
    this.frtTrySucRate2 = parseInt(analysisInfo.frtTrySucRate2);
    this.frtTrySucRate3 = parseInt(analysisInfo.frtTrySucRate3);
    this.frtTrySucRate4 = parseInt(analysisInfo.frtTrySucRate4) || 0;
    this.blkUseSucRate0 = analysisInfo.blkUseSucRate0;
    this.blkUseSucRate1 = analysisInfo.blkUseSucRate1;
    this.blkUseSucRate2 = analysisInfo.blkUseSucRate2;
    this.blkUseSucRate3 = analysisInfo.blkUseSucRate3;
    this.blkUseSucRate4 = analysisInfo.blkUseSucRate4 || 0;
    this.blkSucMiCnt1 = analysisInfo.blkSucMiCnt1;
    this.blkSucMiCnt2 = analysisInfo.blkSucMiCnt2;
    this.blkSucMiCnt3 = analysisInfo.blkSucMiCnt3;
    this.blkSucMiCnt4 = analysisInfo.blkSucMiCnt4 || 0;
    let totStuTime0 = analysisInfo.totStuTime0;
    this.totalStudyTime = this.durationConvert(totStuTime0);
    let avgSolTime0 = analysisInfo.avgSolTime0;
    this.avgSolTime = this.durationConvert(avgSolTime0);
    this.totalStudyTime1 = this.durationConvert(analysisInfo.totStuTime1);
    this.totalStudyTime2 = this.durationConvert(analysisInfo.totStuTime2);
    this.totalStudyTime3 = this.durationConvert(analysisInfo.totStuTime3);
    this.totalStudyTime4 = this.durationConvert(analysisInfo.totStuTime4);
    this.avgSolTime1 = this.durationConvert(analysisInfo.avgSolTime1);
    this.avgSolTime2 = this.durationConvert(analysisInfo.avgSolTime2);
    this.avgSolTime3 = this.durationConvert(analysisInfo.avgSolTime3);
    this.avgSolTime4 = this.durationConvert(analysisInfo.avgSolTime4);

    // ActiveTab 설정후 Chart데이터 업데이트 처리
    this.changeActiveTab(1);
  },
  methods: {
    toLogin () {
      location.href = '/sso/loginView.do'
    },
    showModal (tpl, title, text) {
      this.modalTitle = title || '로그인을 해주세요';
      this.modalData = text || '로그인을 해주세요';
      this.modal = tpl || 'analysis-alert-template';
      this.isShowModal = true
    },
    getUser (cb) {
      was.post(`${this.API_SERVER_URL}/manage/codmos/user/convert`, {})
        .then(res => {
          switch (res.data.code) {
            case '1000': {
              document.cookie = 'userType=convert; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;';
              if (typeof cb === 'function') cb();
              break
            }
            case '3000':
            case '2000':
            default: {
              this.isLoginPopup = true;
              this.showModal();
              break
            }
          }
        })
        .catch(e => {
          this.isLoginPopup = true;
          this.showModal();
          console.error(e)
        })
    },
    updateChartData (chartData) {
      let chartOptions =
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            fontSize: 0,
            fontColor: "#ee0e08",
          }
        },
        tooltips: {
          enabled: false,
          callbacks: {
            label: function (tooltipItems, data) {
              console.log(data);
              return tooltipItems.yLabel + '£'
            }
          },
          tooltipTitleFontSize: 14,
          tooltipTitleFontColor: "#ee0e08",
        },
        title: {
          display: false,
          position: 'bottom',
          text: 'Custom Chart Title'
        },
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 100,
          stepSize: 20
        }
      };
      this.$refs.vchart.updateData(chartData, chartOptions);
    },
    durationConvert (secs) {
      let timeArr = (moment.duration(secs, "seconds").format("hh:mm:ss")).split(':');
      let timeStr = '';
      switch (timeArr.length) {
        case 3: {
          timeStr = `${timeArr[0]}시간 ${timeArr[1]}분 ${timeArr[2]}초`;
        } break;
        case 2: {
          timeStr = `${timeArr[0]}분 ${timeArr[1]}초`;
        } break;
        case 1: {
          timeStr = `${timeArr[0] === '00' ? '0' : timeArr[0]}초`;
        } break;
      }
      return timeStr;
    },
    changeActiveTab (idx) {
      this.activetab = idx;
      let chartData;
      switch (idx) {
        // 전체탭
        case 1: {
          chartData = {
            labels: ['', '', ''],
            datasets:
              [
                {
                  backgroundColor: 'rgba(71,236,118,0.8)',     // #47ec76
                  data: [this.misSucRate4, this.blkUseSucRate4, this.frtTrySucRate4],
                  borderWidth: 0.1,
                  pointRadius: 0
                },
                {
                  backgroundColor: 'rgba(71,181,255,0.8)',     // #47b5ff
                  data: [this.misSucRate3, this.blkUseSucRate3, this.frtTrySucRate3],
                  borderWidth: 0.1,
                  pointRadius: 0
                },
                {
                  backgroundColor: 'rgba(255,238,48,0.8)',      // #ffee30
                  data: [this.misSucRate2, this.blkUseSucRate2, this.frtTrySucRate2],
                  borderWidth: 0.1,
                  pointRadius: 0
                },
                {
                  backgroundColor: 'rgba(255,119,87,0.8)',    // #ff7757
                  data: [this.misSucRate1, this.blkUseSucRate1, this.frtTrySucRate1],
                  borderWidth: 0.1,
                  pointRadius: 0
                }
              ]
          };
        } break;
        case 2: {
          chartData = {
            labels: ['', '', ''],
            datasets:
              [
                {
                  backgroundColor: 'rgba(255,119,87,0.8)',    // #ff7757
                  data: [this.misSucRate1, this.blkUseSucRate1, this.frtTrySucRate1],
                  borderWidth: 0.1,
                  pointRadius: 0
                }
              ]
          };
        } break;
        case 3: {
          chartData = {
            labels: ['', '', ''],
            datasets:
              [
                {
                  backgroundColor: 'rgba(255,238,48,0.8)',      // #ffee30
                  data: [this.misSucRate2, this.blkUseSucRate2, this.frtTrySucRate2],
                  borderWidth: 0.1,
                  pointRadius: 0
                }
              ]
          };
        } break;
        case 4: {
          chartData = {
            labels: ['', '', ''],
            datasets:
              [
                {
                  backgroundColor: 'rgba(71,181,255,0.8)',     // #47b5ff
                  data: [this.misSucRate3, this.blkUseSucRate3, this.frtTrySucRate3],
                  borderWidth: 0.1,
                  pointRadius: 0
                }
              ]
          };
        } break;
        case 5: {
          chartData = {
            labels: ['', '', ''],
            datasets:
              [
                {
                  backgroundColor: 'rgba(71,236,118,0.8)',     // #47ec76
                  data: [this.misSucRate4, this.blkUseSucRate4, this.frtTrySucRate4],
                  borderWidth: 0.1,
                  pointRadius: 0
                }
              ]
          };
        } break;
      }

      chartData.datasets.push({ data: [0, 100], borderColor: 'rgba(0,0,0,0)', pointRadius: 0 })

      this.updateChartData(chartData);
    }
  }
}
</script>
<style lang="less">
@import "../assets/styles/analysis/analysis_detail";
</style>



// WEBPACK FOOTER //
// src/components/CodmosAnalysisDetail.vue